'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import { BORDER } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import Border from 'ContentComponents/cmv2/fields/Border';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class BorderContentOptions extends Component {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(ToolFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`defaultLabels.${BORDER}`)
      }),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        allow_custom_border_sides: true,
        inputComponent: Border,
        onFieldChange: this.onDefaultChange,
        value: field[DEFAULT],
        readOnly: readOnly
      })
    });
  }

}

BorderContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};
export default BorderContentOptions;